import type { ReferencedLearningActivity } from "types";

export const handleWidth: IHandleWidth = 
(
  isTablet,
  isLarge,
  isXLarge
) => {
  if(isTablet) {
    return "100%";
  }
  if (isXLarge) return "32rem";
  if (isLarge) return "24rem";

  return "calc(37.5% - 1.5rem)";
};


type IHandleWidth = (
    isTablet:boolean, 
    isLarge:boolean, 
    isXLarge:boolean, 
    isActive:boolean, 
) => string

export const handleRem = (valueInPx: number) => valueInPx / 16; 

export const thereAreClassrooms = (learningActivities: ReferencedLearningActivity[]) =>
  learningActivities?.some((la) =>
    la.learningObjectTypology === "DA_VIRTUAL_CLASS"
    || la.learningObjectTypology === "DA_PHYSICAL_CLASS");
